import Link from "@/components/link";
import { ArrowLeft, Download } from "lucide-react";

export default function Cv() {
  return (
    <main className="min-h-screen bg-white">
      <div className="container mx-auto py-8 px-4 md:px-6">
        <div className="flex justify-between items-center mb-8">
          <Link
            href="/"
            className="inline-flex items-center text-gray-700 hover:text-gray-900"
          >
            <ArrowLeft size={16} className="mr-2" />
            Back to home
          </Link>
          <button
            onClick={() => {
              const link = document.createElement("a");
              link.href = "/docs/Resume.pdf";
              link.download = "Resume.pdf";
              document.body.appendChild(link);
              link.click();
              document.body.removeChild(link);
            }}
            className="inline-flex items-center px-4 py-2 bg-gray-800 text-white rounded hover:bg-gray-700 transition-colors"
          >
            <Download size={16} className="mr-2" />
            Download PDF
          </button>
        </div>

        <div className="max-w-4xl mx-auto bg-white p-8 shadow-sm print:shadow-none">
          <div className="text-center mb-8">
            <h1 className="text-3xl font-bold">Isaac Bautista Silva</h1>
            <p className="text-xl">B.S. in Physics</p>
            <div className="mt-4 text-gray-600">
              <p>
                <a href="mailto:me@isaacbau.com" className="hover:underline">
                  me@isaacbau.com
                </a>{" "}
                |{" "}
                <a
                  href="https://isaacbau.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="hover:underline"
                >
                  isaacbau.com
                </a>{" "}
                |{" "}
                <a
                  href="https://linkedin.com/in/isaacbau"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="hover:underline"
                >
                  LinkedIn
                </a>
              </p>
            </div>
          </div>

          <section className="mb-8">
            <h2 className="text-xl font-bold border-b-2 border-gray-300 pb-1 mb-4">
              Education
            </h2>

            <div className="mb-4">
              <div className="flex justify-between items-start">
                <div>
                  <h3 className="font-bold">
                    Tecnológico de Monterrey Campus Monterrey
                  </h3>
                  <p>B.S. Physics</p>
                  <p>Monterrey, Mexico</p>
                </div>
                <p className="text-right">07.2018 - 04.2023</p>
              </div>
            </div>

            <div className="mb-4">
              <div className="flex justify-between items-start">
                <div>
                  <h3 className="font-bold">Technische Universität Dresden</h3>
                  <p>
                    B.S. Physics (Exchange) – Full scholarship by the German
                    Academic Exchange Service (DAAD)
                  </p>
                  <p>Dresden, Germany</p>
                </div>
                <p className="text-right">07.2021 - 03.2022</p>
              </div>
            </div>

            <div className="mb-4">
              <div className="flex justify-between items-start">
                <div>
                  <h3 className="font-bold">TheResidency</h3>
                  <p>Accelerator Program for Founders and Researchers</p>
                  <p>San Francisco, USA</p>
                </div>
                <p className="text-right">01.2024 - 05.2024</p>
              </div>
            </div>

            <p className="mt-4 text-sm">
              <span className="font-semibold">Significant Courses:</span>{" "}
              Mathematical Physics, Solid State Physics, Linear Algebra,
              Numerical Methods, Physics Computing, Quantum Physics, Parallel
              and High Performance Computing (Germany), Machine Learning
              (Germany)
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-xl font-bold border-b-2 border-gray-300 pb-1 mb-4">
              Work Experience
            </h2>

            <div className="mb-6">
              <div className="flex justify-between items-start">
                <h3 className="font-bold">Bracket Bot</h3>
                <p>San Francisco, CA</p>
              </div>
              <div className="flex justify-between items-start">
                <p className="italic">Head of ML</p>
                <p>04.2026 – Current</p>
              </div>
              <ul className="list-disc ml-5 mt-2">
                <li>
                  Architected the end-to-end robot learning stack, from teleop
                  data capture and dataset preprocessing to multi-GPU training
                  of vision-language-action policies (π0, ACT, Diffusion Policy,
                  SmolVLA).
                </li>
                <li>
                  Engineered and deployed real-time policy inference from cloud
                  GPUs to robots in the field over a low-latency relay, enabling
                  closed-loop manipulation.
                </li>
                <li>
                  Led development of the ML cloud platform behind the fleet:
                  dataset ingestion and visualization, fleet telemetry,
                  on-demand GPU provisioning, and remote teleoperation.
                </li>
              </ul>
            </div>

            <div className="mb-6">
              <div className="flex justify-between items-start">
                <h3 className="font-bold">Lawgic</h3>
                <p>Remote</p>
              </div>
              <div className="flex justify-between items-start">
                <p className="italic">Senior Software Engineer</p>
                <p>05.2025 – 11.2025</p>
              </div>
              <ul className="list-disc ml-5 mt-2">
                <li>
                  Developed and deployed a real-time legal information retrieval
                  platform using RAG architecture, live web search, vector
                  embeddings, and LLMs to synthesize knowledge across
                  heterogeneous legal sources.
                </li>
                <li>
                  Designed multi-stage retrieval and reasoning pipelines that
                  dynamically aggregated case law, statutes, and web data to
                  generate context-aware insights for legal research and
                  truth-seeking workflows.
                </li>
                <li>
                  Developed recursive retrieval workflows to iteratively refine
                  queries and surface more relevant legal information.
                </li>
              </ul>
            </div>

            <div className="mb-6">
              <div className="flex justify-between items-start">
                <h3 className="font-bold">
                  Zepheon{" "}
                  <a
                    href="https://zepheon.com"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-gray-500 text-sm hover:underline"
                  >
                    [link]
                  </a>
                </h3>
                <p>Remote</p>
              </div>
              <div className="flex justify-between items-start">
                <p className="italic">Founder</p>
                <p>05.2024 – 05.2025</p>
              </div>
              <ul className="list-disc ml-5 mt-2">
                <li>
                  Launched and scaled a ML-consulting studio that partners with
                  seed-stage startups to turn research ideas into shipped
                  products.
                </li>
                <li>
                  Completed 14 different AI projects, ranging from training and
                  distilling models for faster inference to enterprise level
                  Agents to developing RAG pipelines for tens of thousands of
                  legal documents.
                </li>
                <li>
                  Delivered full-stack solutions: from training or fine tuning
                  the models to APIs in .NET and FastAPI, all the way to clean
                  React interfaces on the front end.
                </li>
              </ul>
            </div>

            <div className="mb-6">
              <div className="flex justify-between items-start">
                <h3 className="font-bold">Porsche</h3>
                <p>Stuttgart, Germany</p>
              </div>
              <div className="flex justify-between items-start">
                <p className="italic">Machine Learning Intern</p>
                <p>04.2022 – 08.2022</p>
              </div>
              <ul className="list-disc ml-5 mt-2">
                <li>
                  Developed and deployed deep-learning models for Porsche's
                  next-generation electric vehicle platform, taking projects
                  from proof of concept to on-car deployment.
                </li>
                <li>
                  Designed and validated multi-sensor tracking / localization
                  algorithms that improved fleet-level position accuracy and
                  robustness under high-speed scenarios.
                </li>
                <li>
                  Led the over-the-air pipeline for automatic model updates,
                  ensuring every prototype received fresh weights after the best
                  training rounds.
                </li>
              </ul>
            </div>
          </section>

          <section>
            <h2 className="text-xl font-bold border-b-2 border-gray-300 pb-1 mb-4">
              Projects
            </h2>

            <div className="mb-6">
              <div className="flex justify-between items-start">
                <h3 className="font-bold">
                  miniSAM, Segment Anything Model GPU-Free{" "}
                  <a
                    href="https://minisam.isaacbau.com"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-gray-500 text-sm hover:underline"
                  >
                    [link]
                  </a>
                </h3>
                <p>2025</p>
              </div>
              <ul className="list-disc ml-5 mt-2">
                <li>Distilled Meta's SAM</li>
                <li>Ran it in the browser</li>
                <li>Shipped it as React components</li>
              </ul>
            </div>

            <div className="mb-6">
              <div className="flex justify-between items-start">
                <h3 className="font-bold">
                  Diffusion Math from Scratch, Video Lectures{" "}
                  <a
                    href="https://isaacbau.com/diffusion"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-gray-500 text-sm hover:underline"
                  >
                    [link]
                  </a>
                </h3>
                <p>2025</p>
              </div>
              <ul className="list-disc ml-5 mt-2">
                <li>
                  Derived the mathematics behind Diffusion from absolute first
                  principles, in a series of lectures with each one of the
                  concepts explained by hand.
                </li>
                <li>
                  Recreated all of the individual papers from the original idea
                  to state of the start: Autograd Engine, UNet, DDPMs, Improved
                  DDPMs, VAEs, Attention, etc. All code available online.
                </li>
                <li>
                  Developed my own educational-tech software{" "}
                  <a
                    href="https://infini.computer"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-gray-500 hover:underline"
                  >
                    [link]
                  </a>{" "}
                  to teach and test all of the concepts in Diffusion. It has a
                  self hosted backend that runs text-to-image, inpainting,
                  segmentation, ControlNets, etc.
                </li>
              </ul>
            </div>
          </section>
        </div>
      </div>

      <style>{`
        @media print {
          body {
            padding: 0;
            margin: 0;
          }

          button,
          a[href="/"] {
            display: none !important;
          }

          .container {
            padding: 0 !important;
            max-width: 100% !important;
          }

          .shadow-sm {
            box-shadow: none !important;
          }
        }
      `}</style>
    </main>
  );
}
